const PAYMENT_REDIRECT_KEY = 'driver-recharge-payment-redirect'

type TResetHandler = () => void

const resetHandlers = new Set<TResetHandler>()

export const markPaymentRedirect = (): void => {
    sessionStorage.setItem(PAYMENT_REDIRECT_KEY, '1')
}

export const clearPaymentRedirect = (): void => {
    sessionStorage.removeItem(PAYMENT_REDIRECT_KEY)
}

export const hasPaymentRedirect = (): boolean => {
    return sessionStorage.getItem(PAYMENT_REDIRECT_KEY) === '1'
}

export const subscribePaymentReturn = (handler: TResetHandler): (() => void) => {
    resetHandlers.add(handler)

    return () => resetHandlers.delete(handler)
}

const handlePaymentReturn = (): void => {
    if (!hasPaymentRedirect()) {
        return
    }

    clearPaymentRedirect()
    for (const handler of resetHandlers) {
        handler()
    }
}

if (globalThis.window !== undefined) {
    window.addEventListener('pageshow', handlePaymentReturn)
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
            handlePaymentReturn()
        }
    })
    window.addEventListener('focus', handlePaymentReturn)
}
